import { useQuery } from 'react-query';

import { ActiveDataRoomUser, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useActiveDataRoomUsersQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.Lookups.ActiveDataRoomUsers(guid),
		() =>
			AxiosUtils.getResponseData<ActiveDataRoomUser[]>(
				api.get(CerebroApiEndpoints.Lookups.ActiveDataRoomUsers(guid))
			),
		{ enabled: guid !== undefined }
	);
}
